import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import './LoadingIndicator.scss';

export type LoadingIndicatorProps = {
  size?: 'sm';
};

export function LoadingIndicator({size = 'sm'}: LoadingIndicatorProps) {
  return (
    <div className='qep-loading-indicator' role='status'>
      <Spinner animation='grow' className='dot dot-1' size={size} />
      <Spinner animation='grow' className='dot dot-2' size={size} />
      <Spinner animation='grow' className='dot dot-3' size={size} />
    </div>
  );
}
